(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const desktopText =
    'Używamy opcjonalnych plików cookie do analizy ruchu, pomiaru skuteczności reklam i ulepszania działania sklepu. Możesz zezwolić na wszystkie lub spersonalizować ustawienia.';
  const originalTextByNode = new WeakMap();
  const originalTitleByNode = new WeakMap();
  const textNodeByPolicyLink = new WeakMap();
  const privacyUiSelector = '#shopify-pc__banner, #shopify-pc__prefs, [id^="shopify-pc__prefs"]';
  let isPrivacyLocked = false;
  let isScrollLocked = false;
  let savedScrollY = 0;
  let syncFrame = null;

  function protectPolishOneLetterWords(text) {
    return text.replace(/(^|[\s([{„“"'])([AaIiOoUuWwZz]) /g, '$1$2\u00a0');
  }

  function getLocale() {
    const locale = document.documentElement.lang || window.Shopify?.locale || 'pl';

    return locale.toLowerCase().split('-')[0];
  }

  function ensureBannerTitle() {
    const body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');
    const paragraph = body?.querySelector('p');

    if (!body || !paragraph || body.querySelector('.milaau-cookie-banner__title')) {
      return;
    }

    const emptyHeading = Array.from(body.querySelectorAll('h1, h2, h3, h4, h5, h6')).find(
      (heading) =>
        !heading.textContent.trim() &&
        Boolean(heading.compareDocumentPosition(paragraph) & Node.DOCUMENT_POSITION_FOLLOWING),
    );
    const title = emptyHeading || document.createElement('h2');

    originalTitleByNode.set(title, {
      created: !emptyHeading,
      text: title.textContent,
    });
    title.classList.add('milaau-cookie-banner__title');
    title.textContent = 'Pliki cookie';

    if (!emptyHeading) {
      body.insertBefore(title, paragraph);
    }
  }

  function restoreBannerTitle() {
    const title = document.querySelector('#shopify-pc__banner .milaau-cookie-banner__title');
    const originalTitle = title && originalTitleByNode.get(title);

    if (!title || !originalTitle) {
      return;
    }

    if (originalTitle.created) {
      title.remove();
      return;
    }

    title.classList.remove('milaau-cookie-banner__title');
    title.textContent = originalTitle.text;
    originalTitleByNode.delete(title);
  }

  function getBannerTextNode() {
    const paragraph = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    const policyLink = document.querySelector('#shopify-pc__banner__body-policy-link');

    if (!policyLink) {
      return null;
    }

    const savedTextNode = textNodeByPolicyLink.get(policyLink);

    if (savedTextNode?.isConnected) {
      return savedTextNode;
    }

    if (!paragraph || !paragraph.contains(policyLink)) {
      return null;
    }

    let node = policyLink.previousSibling;

    while (node) {
      if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
        textNodeByPolicyLink.set(policyLink, node);
        return node;
      }

      node = node.previousSibling;
    }

    return null;
  }

  function updateBannerText() {
    const textNode = getBannerTextNode();

    if (!textNode) {
      return;
    }

    if (!originalTextByNode.has(textNode)) {
      originalTextByNode.set(textNode, textNode.nodeValue);
    }

    const nextText = `${protectPolishOneLetterWords(desktopText)} `;

    if (textNode.nodeValue !== nextText) {
      textNode.nodeValue = nextText;
    }
  }

  function restoreBannerText() {
    const textNode = getBannerTextNode();
    const originalText = textNode && originalTextByNode.get(textNode);

    if (!textNode || originalText === undefined) {
      return;
    }

    textNode.nodeValue = originalText;
    originalTextByNode.delete(textNode);
  }

  function movePolicyLinkToDesktopRow() {
    const banner = document.querySelector('#shopify-pc__banner');
    const policyLink = banner?.querySelector('#shopify-pc__banner__body-policy-link');
    const buttons = banner?.querySelector('.shopify-pc__banner__btns');

    if (!banner || !policyLink || !buttons) {
      return;
    }

    let policyRow = banner.querySelector('.milaau-cookie-banner__policy-row');

    if (!policyRow) {
      policyRow = document.createElement('div');
      policyRow.classList.add('milaau-cookie-banner__policy-row');
      buttons.insertAdjacentElement('afterend', policyRow);
    }

    if (policyLink.parentNode !== policyRow) {
      policyRow.appendChild(policyLink);
    }
  }

  function syncBannerContent() {
    if (getLocale() === 'pl') {
      ensureBannerTitle();
      updateBannerText();
    } else {
      restoreBannerTitle();
      restoreBannerText();
    }

    movePolicyLinkToDesktopRow();
  }

  function isElementVisible(element) {
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    const styles = window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      element.getClientRects().length > 0
    );
  }

  function isPrivacyUiVisible() {
    return Array.from(document.querySelectorAll(privacyUiSelector)).some(isElementVisible);
  }

  function lockPrivacyUi() {
    if (isPrivacyLocked) {
      return;
    }

    document.documentElement.classList.add('milaau-cookie-lock');
    document.body.classList.add('milaau-cookie-lock');
    isPrivacyLocked = true;
  }

  function unlockPrivacyUi() {
    if (!isPrivacyLocked) {
      return;
    }

    document.documentElement.classList.remove('milaau-cookie-lock');
    document.body.classList.remove('milaau-cookie-lock');
    isPrivacyLocked = false;
  }

  function lockPageScroll() {
    if (isScrollLocked) {
      return;
    }

    savedScrollY = window.scrollY;
    document.documentElement.style.setProperty('--milaau-cookie-scroll-y', `${savedScrollY}px`);
    document.documentElement.classList.add('milaau-cookie-scroll-lock');
    document.body.classList.add('milaau-cookie-scroll-lock');
    isScrollLocked = true;
  }

  function unlockPageScroll() {
    if (!isScrollLocked) {
      return;
    }

    const restoreScrollY = savedScrollY;

    document.documentElement.classList.remove('milaau-cookie-scroll-lock');
    document.body.classList.remove('milaau-cookie-scroll-lock');
    document.documentElement.style.removeProperty('--milaau-cookie-scroll-y');
    isScrollLocked = false;
    savedScrollY = 0;
    window.scrollTo(0, restoreScrollY);
  }

  function syncPrivacyUi() {
    syncFrame = null;
    syncBannerContent();

    if (isPrivacyUiVisible()) {
      lockPrivacyUi();
      unlockPageScroll();
    } else {
      unlockPageScroll();
      unlockPrivacyUi();
    }
  }

  function scheduleSync() {
    if (syncFrame !== null) {
      return;
    }

    syncFrame = window.requestAnimationFrame(syncPrivacyUi);
  }

  const observer = new MutationObserver(scheduleSync);

  if (document.body) {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      childList: true,
      subtree: true,
    });
  }

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', scheduleSync);
  } else {
    desktopQuery.addListener(scheduleSync);
  }

  scheduleSync();
})();
